export * from './projekte-hochgezaehlt.interface';
